module.exports = __webpack_public_path__ + "media/application/images/icons/chart-blue-f7d129798bc94790cb581d2b5741fdca.svg";